<style></style>
<template><portal-404/></template>
<script>export default {}
</script>



// WEBPACK FOOTER //
// src/pages/404.vue